import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";
import { CondominioContextoDTO } from "types/dto/CondominioContextoDTO";
import { Page } from "types/dto/Page";
import { RequestCondominiosContextoPaginados } from "types/request/RequestCondominiosContextoPaginados";

export const useGetCondominiosContextoPaginados = (
  request: RequestCondominiosContextoPaginados,
  deveBuscarRegistros: boolean
) => {
  const onError = () => {
    toast.error("Erro ao buscar condomínios");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 2,
  };

  return useFetch<Page<CondominioContextoDTO>>({
    key: ["condominios-contexto-paginados", request.query, request.page],
    url: api.condominio.getCondominiosContextoPaginados,
    params: request,
    enabled: deveBuscarRegistros,
    onError,
    config,
  });
};
